import { MARQUEE_ITEMS } from "@/data/site";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-gold-400/20 bg-navy-900/60 py-4"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-mono-tech text-xs tracking-[0.3em] text-gold-300/90">
              {item}
            </span>
            <span className="text-gold-400/60">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
